module.exports = __webpack_public_path__ + "img/about-m-slide-1.95af01ea.jpg";